<template>
  <el-dialog
    :title="$t('deleteAttrValue.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('deleteAttrValue.confirmDeleteAttributeValue') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteAttrValue.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAttrValue">{{ $t('deleteAttrValue.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteAttrValue } from '@/api/dev/attrValueApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAttrValue',
  data() {
    return {
      dialogVisible: false,
      deleteAttrValueInfo: {
        valueId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(params) {
      this.deleteAttrValueInfo = {
        valueId: params.valueId,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteAttrValueInfo = {
        valueId: '',
        shopId: ''
      }
    },
    async deleteAttrValue() {
      try {
        await deleteAttrValue(this.deleteAttrValueInfo)
        this.$message.success(this.$t('deleteAttrValue.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除属性值失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>